export const SET_USERNAME = 'SET_USERNAME'
export const SET_BATTLESHIP = 'SET_BATTLESHIP'

export const START_GAME = 'START_GAME'
export const RESET_GAME = 'RESET_GAME'
export const GAME_OVER = 'GAME_OVER'

export const INIT_GAME = 'INIT_GAME'
export const MAIN_MENU = 'MAIN_MENU'

export const MOVE_LEFT = 'MOVE_LEFT'
export const MOVE_RIGHT = 'MOVE_RIGHT'

export const BULLET_CREATE = 'BULLET_CREATE'
export const BULLET_REMOVE = 'BULLET_REMOVE'

export const ENEMY_ADD = 'ENEMY_ADD'
export const ENEMY_REMOVE = 'ENEMY_REMOVE'
export const ENEMY_HITED = 'ENEMY_HITED'
export const ENEMY_CORDS = 'ENEMY_CORDS'

export const PLAYER_ADD_POINTS = 'PLAYER_ADD_POINTS'
export const PLAYER_REMOVE_HP = 'PLAYER_REMOVE_HP'